import { Navigate, Route, Routes, useLocation } from 'react-router-dom'
import { Login } from 'components/pages/login'
import { CompanyListPage } from 'components/pages/company_list_page'
import { NotFoundPage } from 'components/pages/not_found_page'
import { CompanyCreate } from 'components/pages/company_create'
import { CompanyUpdate } from 'components/pages/company_update'
import { CompanyDetailPage } from 'components/pages/company_detail_page'
import { AdminPage } from 'components/pages/admin_page'
import { DashboardPage } from 'components/pages/dashboard_page'
import { FocusCustomersPage } from 'components/pages/focus_customers_page'
import { ProjectsTalentsPage } from 'components/pages/projects_talents_page'
import { ReportsPage } from 'components/pages/reports_page'
import { ContractsPage } from 'components/pages/contracts_page'
import { SettingsPage } from 'components/pages/settings_page'
import { TasksPage } from 'components/pages/tasks_page'

export const Routing = () => {
  const location = useLocation()

  return (
    <Routes>
      <Route
        path="/"
        element={
          <Navigate to={'/login'} state={{ from: location }} replace={false} />
        }
      />
      <Route path="login" element={<Login />} />
      <Route path="sign-up" element={<></>} />
      <Route path="dashboard" element={<DashboardPage />} />
      <Route path="focus-customers" element={<FocusCustomersPage />} />
      <Route path="projects-talents" element={<ProjectsTalentsPage />} />
      <Route path="reports" element={<ReportsPage />} />
      <Route path="contracts" element={<ContractsPage />} />
      <Route path="settings" element={<SettingsPage />} />
      <Route path="company">
        <Route index element={<CompanyListPage />} />
        <Route path="new" element={<CompanyCreate />} />
        <Route path=":companyId" element={<CompanyDetailPage />} />
        <Route path=":companyId/edit" element={<CompanyUpdate />} />
      </Route>
      <Route path="admin" element={<AdminPage />} />
      <Route path="tasks" element={<TasksPage />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  )
}
